import React from 'react';
import "./AdsB1.scss";
import { IoCloudUploadOutline } from "react-icons/io5";

export default function AdsB1() {
  return (
    <div className='adsb1-container'>
      <div className=' d-flex gap-2 '>
        <div className=' d-flex flex-column gap-4'>
          <div className='right-part '>
            <div className='upright-div'>
              <div className='inner-div'>
                <IoCloudUploadOutline className="upload-icon" />
                <span className='upload-text'>
                  Drop files here or click to upload <br /> W872 x H50
                </span>
              </div>
            </div>

            <div className='min-img'>
              <div className='min-div'></div>
              <div className='min-div'></div>
              <div className='min-div plus'>+</div>
            </div>

            <div className='options-section'>
              <div className='checkbox-group'>
                <label className='checkbox-label'>
                  <input type="checkbox" name="active" className='checkbox-input' />
                  <span className='checkbox-text'>Active</span>
                </label>

                <label className='checkbox-label'>
                  <input type="checkbox" name="draft" className='checkbox-input' />
                  <span className='checkbox-text'>Draft</span>
                </label>
              </div>

              <select className='select-options'>
                <option value="">Select page</option>
                <option value="">Ads2</option>
                <option value="">Ads3</option>
                <option value="">Ads4</option>
              </select>
            </div>
          </div>
           <div className='right-part '>
            <div className='upright-div'>
              <div className='inner-div'>
                <IoCloudUploadOutline className="upload-icon" />
                <span className='upload-text'>
                  Drop files here or click to upload <br /> W872 x H50
                </span>
              </div>
            </div>

            <div className='min-img'>
              <div className='min-div'></div>
              <div className='min-div'></div>
              <div className='min-div plus'>+</div>
            </div>

            <div className='options-section'>
              <div className='checkbox-group'>
                <label className='checkbox-label'>
                  <input type="checkbox" name="active" className='checkbox-input' />
                  <span className='checkbox-text'>Active</span>
                </label>

                <label className='checkbox-label'>
                  <input type="checkbox" name="draft" className='checkbox-input' />
                  <span className='checkbox-text'>Draft</span>
                </label>
              </div>

              <select className='select-options'>
                <option value="">Select page</option>
                <option value="">Ads2</option>
                <option value="">Ads3</option>
                <option value="">Ads4</option>
              </select>
            </div>
          </div>
        </div>
        <div className='d-flex  gap-4'>
    <div className='d-flex  flex-column '>


            <div className='upleft-div'>
              <div className='inner-div'>
                <IoCloudUploadOutline className="upload-icon" />
                <span className='upload-text'>
                  Drop files here or click to upload <br /> W872 x H50
                </span>
              </div>
            </div>

            <div className='left-min-img'>
              <div className='min-divv'></div>
              <div className='min-divv'></div>
              <div className='min-divv plus'>+</div>
            </div>

            <div className='options-section flex-column'>
              <div className='checkbox-group'>
                <label className='checkbox-label'>
                  <input type="checkbox" name="active" className='checkbox-input' />
                  <span className='checkbox-text'>Active</span>
                </label>

                <label className='checkbox-label'>
                  <input type="checkbox" name="draft" className='checkbox-input' />
                  <span className='checkbox-text'>Draft</span>
                </label>
              </div>

              <select className='select-options'>
                <option value="">Select page</option>
                <option value="">Ads2</option>
                <option value="">Ads3</option>
                <option value="">Ads4</option>
              </select>
            </div>
         
          


        </div> 
           <div className='d-flex  flex-column '>


            <div className='upleft-div'>
              <div className='inner-div'>
                <IoCloudUploadOutline className="upload-icon" />
                <span className='upload-text'>
                  Drop files here or click to upload <br /> W872 x H50
                </span>
              </div>
            </div>

            <div className='left-min-img'>
              <div className='min-divv'></div>
              <div className='min-divv'></div>
              <div className='min-divv plus'>+</div>
            </div>

            <div className='options-section flex-column'>
              <div className='checkbox-group'>
                <label className='checkbox-label'>
                  <input type="checkbox" name="active" className='checkbox-input' />
                  <span className='checkbox-text'>Active</span>
                </label>

                <label className='checkbox-label'>
                  <input type="checkbox" name="draft" className='checkbox-input' />
                  <span className='checkbox-text'>Draft</span>
                </label>
              </div>

              <select className='select-options'>
                <option value="">Select page</option>
                <option value="">Ads2</option>
                <option value="">Ads3</option>
                <option value="">Ads4</option>
              </select>
            </div>
         
          


        </div>  
        
          <div className='d-flex  flex-column '>


            <div className='upleft-div'>
              <div className='inner-div'>
                <IoCloudUploadOutline className="upload-icon" />
                <span className='upload-text'>
                  Drop files here or click to upload <br /> W872 x H50
                </span>
              </div>
            </div>

            <div className='left-min-img'>
              <div className='min-divv'></div>
              <div className='min-divv'></div>
              <div className='min-divv plus'>+</div>
            </div>

            <div className='options-section flex-column'>
              <div className='checkbox-group'>
                <label className='checkbox-label'>
                  <input type="checkbox" name="active" className='checkbox-input' />
                  <span className='checkbox-text'>Active</span>
                </label>

                <label className='checkbox-label'>
                  <input type="checkbox" name="draft" className='checkbox-input' />
                  <span className='checkbox-text'>Draft</span>
                </label>
              </div>

              <select className='select-options'>
                <option value="">Select page</option>
                <option value="">Ads2</option>
                <option value="">Ads3</option>
                <option value="">Ads4</option>
              </select>
            </div>
         
          


        </div>
        </div>
    
      </div>
         <div className="form-buttons">
          <button type="submit" className="publish">CONFIRM</button>
          <button type="button" className="cancel">CANCEL</button>
        </div>
    </div>
  );
}
